var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.pubInfo ? _c('Reader', _vm._b({}, 'Reader', _vm.readerProps, false)) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }